module.exports = __webpack_public_path__ + "assets/outlineIcon-b6383b.svg";